import { createSlice } from '@reduxjs/toolkit';
import { FaHome, FaChartBar, FaBook, FaLifeRing, FaFileAlt, FaCog, FaListAlt, FaKey, FaUserSlash } from "react-icons/fa";

const initialState = {
  employeeDetails: JSON.parse(localStorage.getItem("user")) || null,
  merchantFormData: null,
  onboardingitems: [
    { title: "User Profile", view: "totalcount", icon: <FaHome size={20} /> },
    { title: "Create Role", view: "createrole", icon: <FaChartBar size={20} /> },
    { title: "Onboarding", view: "OnboardingBasicDetails", icon: <FaBook size={20} /> },
    { title: "Onboarding Completed", view: "OnboardingComplete", icon: <FaLifeRing size={20} /> },
    { title: "Onboarding Pending", view: "OnboardingPending", icon: <FaFileAlt size={20} /> },
    { title: "Onboarding Rejected", view: "OnboardingRejeceted", icon: <FaFileAlt size={20} /> },
    { title: "Merchant Edit", view: "merchnatedit", icon: <FaLifeRing size={20} /> },
    { title: "Search User", view: "searchuser", icon: <FaHome size={20} /> },
    // { title: "Feedback", view: "feedback", icon: <FaCommentDots size={20} /> },
    // { title: "Settings", view: "settings", icon: <FaCog size={20} /> },
  ],
  compalinceitems: [
    { title: "Dashboard", view: "kycdashboard", icon: <FaHome size={20} /> },
    { title: "Search User", view: "searchuser", icon: <FaHome size={20} /> },
    { title: "Transactions Report", view: "transactionsreport1", icon: <FaCog size={20} /> },
    { title: "Merchant List", view: "merchantlist", icon: <FaListAlt size={20} /> },
    // { title: "Reset Password", view: "resetpassword", icon: <FaHome size={20} /> },
    { title: "Merchant Bank Approve", view: "bankapprove", icon: <FaHome size={20} /> }
    // { title: "Reports", view: "reports", icon: <FaChartBar size={20} /> },
    // { title: "Ledger", view: "ledger", icon: <FaBook size={20} /> },
    // { title: "Raise Ticket", view: "raise-ticket", icon: <FaLifeRing size={20} /> },
    // { title: "Documents", view: "documents", icon: <FaFileAlt size={20} /> },
    // { title: "Feedback", view: "feedback", icon: <FaCommentDots size={20} /> },
    // { title: "Settings", view: "settings", icon: <FaCog size={20} /> },
  ],

  superonboardingitems: [
    { title: "User Profile", view: "totalcount", icon: <FaHome size={20} /> },
    { title: "Create Role", view: "createroleadmin", icon: <FaChartBar size={20} /> },
    { title: "Create Dummy Role", view: "createdummyrole", icon: <FaChartBar size={20} /> },
    { title: "Onboarding", view: "OnboardingBasicDetails", icon: <FaBook size={20} /> },
    { title: "Onboarding Completed", view: "OnboardingComplete", icon: <FaLifeRing size={20} /> },
    { title: "Onboarding Pending", view: "OnboardingPending", icon: <FaFileAlt size={20} /> },
    { title: "Onboarding Rejected", view: "OnboardingRejeceted", icon: <FaFileAlt size={20} /> },
    { title: "Merchant Edit", view: "merchnatedit", icon: <FaLifeRing size={20} /> },
    { title: "Mapping Change", view: "mappingchnage", icon: <FaLifeRing size={20} /> },
    { title: "Cash In", view: "merchanttopup", icon: <FaLifeRing size={20} /> },
    // { title: "Transactions Report", view: "transactionsreport", icon: <FaCog size={20} /> },
    { title: "Transactions Report", view: "transactionsreport1", icon: <FaCog size={20} /> },
    { title: "Routing", view: "routing", icon: <FaCog size={20} /> },
    { title: "Merchant List", view: "merchantlist", icon: <FaListAlt size={20} /> },
    { title: "Hierarchy", view: "adminhierarchy", icon: <FaHome size={20} /> },
    // { title: "Reset Password", view: "resetpassword", icon: <FaHome size={20} /> },
    { title: "Merchant Wallet", view: "merchantwallet", icon: <FaHome size={20} /> },
    { title: "Search User", view: "searchuser", icon: <FaHome size={20} /> },
    { title: "Lien Ledger", view: "lienledger", icon: <FaHome size={20} /> },
    { title: "CDM Card Mapping", view: "cdmledger", icon: <FaHome size={20} /> },
    { title: "CDM Card History", view: "cdmhistory", icon: <FaHome size={20} /> },
    { title: "Bank Details", view: "bankdetails", icon: <FaHome size={20} /> },
    { title: "Merchant Ledger", view: "allmerchantledger", icon: <FaHome size={20} /> },
    { title: "All User", view: "alluser", icon: <FaHome size={20} /> },
    { title: "Rate System", view: "rateset", icon: <FaHome size={20} /> },
    { title: "Invoice Management", view: "uploadinvoice", icon: <FaHome size={20} /> },
    { title: "Qr Upload", view: "qrupload", icon: <FaHome size={20} /> },
    { title: "OD History", view: "adadminhistory", icon: <FaHome size={20} /> },
    { title: "OD Outstanding", view: "odoutstanding", icon: <FaHome size={20} /> },
    { title: "Announcement", view: "announcement", icon: <FaHome size={20} /> },
    { title: "App Version Config", view: "appversionconfig", icon: <FaCog size={20} /> },
    // { title: "Txn Details", view: "txndetails", icon: <FaFileAlt size={20} /> },
    { title: "Reset MPIN", view: "resetmpin", icon: <FaKey size={20} /> },
    { title: "Dormant Users", view: "dormantuser", icon: <FaUserSlash size={20} /> },
  ],


  rmdashboarditems: [
    { title: "Profile", view: "rbdashboard", icon: <FaHome size={20} /> },
    { title: "Hierarchy", view: "hierarchy", icon: <FaHome size={20} /> },
    { title: "Onboarding", view: "OnboardingBasicDetails", icon: <FaBook size={20} /> },
    { title: "Onboarding Rejected", view: "OnboardingRejeceted", icon: <FaFileAlt size={20} /> },
    { title: "Merchant Edit", view: "merchnatedit", icon: <FaLifeRing size={20} /> },
    { title: "Search User", view: "searchuser", icon: <FaHome size={20} /> },
  ],

  payoutaccountingitems: [
    { title: "Profile", view: "payoutdashboard", icon: <FaHome size={20} /> },
    { title: "Cash In", view: "merchanttopup", icon: <FaLifeRing size={20} /> },
    { title: "Transactions Report", view: "transactionsreport1", icon: <FaCog size={20} /> },
    { title: "Search User", view: "searchuser", icon: <FaHome size={20} /> },
    { title: "Invoice Management", view: "uploadinvoice", icon: <FaHome size={20} /> },
    { title: "All User", view: "alluser", icon: <FaHome size={20} /> },
    { title: "Wallet Ledger", view: "merchantwallet", icon: <FaHome size={20} /> },
    { title: "Reset MPIN", view: "resetmpin", icon: <FaKey size={20} /> },
  ],

  accountingitems: [
    { title: "Profile", view: "payoutdashboard", icon: <FaHome size={20} /> },
    { title: "Cash In Report", view: "cashinreport", icon: <FaLifeRing size={20} /> },
    { title: "Transactions Report", view: "transactionsreport1", icon: <FaCog size={20} /> },
    { title: "Search User", view: "searchuser", icon: <FaHome size={20} /> },
    { title: "Invoice Management", view: "uploadinvoice", icon: <FaHome size={20} /> },
    { title: "All User", view: "alluser", icon: <FaHome size={20} /> },
  ],


  accountingiroletems: [
    { title: "Profile", view: "accountingroledashboard", icon: <FaHome size={20} /> },
    { title: "Transactions Report", view: "transactionsreport1", icon: <FaCog size={20} /> },
    { title: "Search User", view: "searchuser", icon: <FaHome size={20} /> },
    { title: "Merchant Ledger", view: "allmerchantledger", icon: <FaHome size={20} /> },
    { title: "Cash In Report", view: "cashinreport", icon: <FaLifeRing size={20} /> },
    { title: "Invoice Management", view: "uploadinvoice", icon: <FaHome size={20} /> },
    { title: "CDM Card History", view: "cdmhistory", icon: <FaHome size={20} /> },
    { title: "All User", view: "alluser", icon: <FaHome size={20} /> },
    { title: "OD Outstanding", view: "odoutstanding", icon: <FaHome size={20} /> },
    { title: "Reset MPIN", view: "resetmpin", icon: <FaKey size={20} /> },
  ],

  zhdashboarditems: [
    { title: "Profile", view: "zhdashboard", icon: <FaHome size={20} /> },
    { title: "Hierarchy", view: "zhhierarchy", icon: <FaHome size={20} /> },
    { title: "Onboarding", view: "OnboardingBasicDetails", icon: <FaBook size={20} /> },
    { title: "Onboarding Rejected", view: "OnboardingRejeceted", icon: <FaFileAlt size={20} /> },
    { title: "Merchant Edit", view: "merchnatedit", icon: <FaLifeRing size={20} /> },
    { title: "Search User", view: "searchuser", icon: <FaHome size={20} /> },
  ],


  rsmdashboarditems: [
    { title: "Profile", view: "rsmdashboard", icon: <FaHome size={20} /> },
    { title: "Hierarchy", view: "rsmhierarchy", icon: <FaHome size={20} /> },
    { title: "Onboarding", view: "OnboardingBasicDetails", icon: <FaBook size={20} /> },
    { title: "Onboarding Rejected", view: "OnboardingRejeceted", icon: <FaFileAlt size={20} /> },
    { title: "Merchant Edit", view: "merchnatedit", icon: <FaLifeRing size={20} /> },
    { title: "Search User", view: "searchuser", icon: <FaHome size={20} /> },
  ],


  shdashboarditems: [
    { title: "Profile", view: "shdashboard", icon: <FaHome size={20} /> },
    { title: "Hierarchy", view: "hierarchysh", icon: <FaHome size={20} /> },
    { title: "Onboarding", view: "OnboardingBasicDetails", icon: <FaBook size={20} /> },
    { title: "Onboarding Rejected", view: "OnboardingRejeceted", icon: <FaFileAlt size={20} /> },
    { title: "Merchant Edit", view: "merchnatedit", icon: <FaLifeRing size={20} /> },
    { title: "Search User", view: "searchuser", icon: <FaHome size={20} /> },
  ],

  asmdashboarditems: [
    { title: "Profile", view: "asmdashboard", icon: <FaHome size={20} /> },
    { title: "Hierarchy", view: "hierarchyasm", icon: <FaHome size={20} /> },
    { title: "Onboarding", view: "OnboardingBasicDetails", icon: <FaBook size={20} /> },
    { title: "Onboarding Rejected", view: "OnboardingRejeceted", icon: <FaFileAlt size={20} /> },
    { title: "Merchant Edit", view: "merchnatedit", icon: <FaLifeRing size={20} /> },
    { title: "Search User", view: "searchuser", icon: <FaHome size={20} /> },
  ],

  Aepsitems: [
    {
      title: "AEPS",
      links: [
        { name: "Transaction Details", view: "aepstxn" },
        { name: "Merchnat Details", view: "aepsmerchantdetails" },
        { name: "Lien Amount", view: "lienamount" },
        { name: "Report", view: "aepsreport" },
      ]
    },

    {
      title: "Settlement",
      links: [
        { name: "Bank Add Request", view: "aepsbankaddrequest" },
        { name: "Delete Account", view: "deleteaccount" },
        { name: "Transaction Details", view: "aepssettletxn" },
        { name: "Report", view: "aepssettlereport" },
      ]
    },
  ],
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action) => {
      state.employeeDetails = action.payload;
    },
    logout: (state) => {
      state.employeeDetails = null;
    },
    saveMerchantFormData: (state, action) => {
      state.merchantFormData = action.payload;
    },

  },
});

export const { login, logout, saveMerchantFormData } = authSlice.actions;
export default authSlice.reducer;